const initialState = {
  isAuthenticated: false,
  newIsAdmin: false,
  newUserType: '',
  appLoaded: false,
  profile: {},
  newToken: null,
  email: '',
};

function authReducer(state, action = {}) {
  const {
    type,
    newToken,
    email,
    newIsAdmin,
    profile = {},
    newUserType,
  } = action;

  switch (type) {
    case 'logout':
      return { ...initialState };
    case 'login':
      return {
        ...state,
        isAuthenticated: true,
        newToken,
        email,
        newIsAdmin,
        newUserType,
      };
    case 'setProfile':
      return {
        ...state,
        appLoaded: true,
        profile,
      };
    default:
      return { ...state };
  }
}

export { initialState, authReducer };
